import { parseApiError } from '../services/api.ts';

export const CRM_APPOINTMENT_CREATE_ERROR_FALLBACK =
  'Não foi possível criar o agendamento.';

export function getCrmAppointmentCreateErrorMessage(error: unknown): string {
  return parseApiError(
    error,
    CRM_APPOINTMENT_CREATE_ERROR_FALLBACK,
  ).message || CRM_APPOINTMENT_CREATE_ERROR_FALLBACK;
}
